import { useEffect } from "react";

/** Follows the OS color scheme by setting data-theme on <html> (no toggle UI). */
export function useSystemTheme() {
	useEffect(() => {
		const mq = window.matchMedia("(prefers-color-scheme: dark)");
		const apply = () =>
			(document.documentElement.dataset.theme = mq.matches ? "dark" : "light");
		apply();
		mq.addEventListener("change", apply);
		return () => mq.removeEventListener("change", apply);
	}, []);
}
